// Hooks
import useTranslation from '@/hooks/translation'

export default function SupportPage() {
  const { t } = useTranslation()

  return (
    <div className="bg-bg min-h-screen pt-120">
      <div className="container">
        <div className="row justify-center">
          <div className="md:col-6 lg:col-5">
            <main className="bg-white border border-dark-10 rounded-lg flex relative">
              <div className="p-30">
                <p className="title-5">{t('pages.support.title')}</p>
                <p className="text-dark-80 mt-10">
                  {t('pages.support.desc')}
                  <a
                    href="mailto:axel@ulysse.com"
                    className="text-primary font-bold underline hover:no-underline"
                  >
                    axel@ulysse.com
                  </a>
                </p>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  )
}
